(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aa-before-after-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    function initTabs(root) {
      if (!root || root.dataset.batInit === 'true') return;
      root.dataset.batInit = 'true';

      var source = root.querySelector('[data-bat-source]');
      var tabsWrap = root.querySelector('[data-bat-tabs]');
      var panelsWrap = root.querySelector('[data-bat-panels]');

      if (source && tabsWrap && panelsWrap) {
        source.querySelectorAll('.aa-bat__tab').forEach(function (tab) {
          tabsWrap.appendChild(tab);
        });
        source.querySelectorAll('.aa-bat__panel').forEach(function (panel) {
          panelsWrap.appendChild(panel);
        });
        source.remove();
      }

      var tabs = root.querySelectorAll('[data-bat-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('data-bat-target');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          root.querySelectorAll('.aa-bat__panel').forEach(function (panel) {
            var isTarget = panel.id === targetId;
            panel.classList.toggle('is-active', isTarget);
            panel.hidden = !isTarget;
          });
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.aa-bat').forEach(initTabs);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
